import { TRuleSources } from 'meta/rule_sources'

const rule_sources = {
  BATTLETOME_STORMCAST_ETERNALS: {
    name: 'Battletome: Stormcast Eternals (2021)',
    type: 'battletome',
  },
  ERRATA_OCTOBER_2021: {
    name: 'Errata (October 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2019/10/3F3KApyA8t95NC7g.pdf',
  },
  ERRATA_DECEMBER_2021: {
    name: 'Errata (December 2021)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2019/10/S5aRxVeqC9NTilRc.pdf',
  },
  ERRATA_JULY_2022: {
    name: 'Errata (July 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2019/10/K12650xacakOrNCt.pdf',
  },
  ERRATA_OCTOBER_2022: {
    name: 'Errata (October 2022)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2019/10/y8MJra9HoDU6VlqR.pdf',
  },
  ERRATA_APRIL_2023: {
    name: 'Errata (April 2023)',
    type: 'errata',
    url: 'https://www.warhammer-community.com/wp-content/uploads/2019/10/eGLbgZceSvG1dJnx.pdf',
  },
} satisfies TRuleSources

export default rule_sources
